
type UnwrapPromise<P extends Promise<unknown>> = P extends PromiseLike<infer V> ? V : never;

export const combinePromises = <Obj extends Record<string | number | symbol, Promise<unknown>>>(
  obj: Obj,
): Promise<
  {
    [P in keyof Obj]: UnwrapPromise<Obj[P]>;
  }
> => {
  const keys = Object.keys(obj);
  const values = Object.values(obj);
  return Promise.all(values).then(results => {
    const combinedResult: any = {};
    results.forEach((result, i) => {
      const key = keys[i];
      combinedResult[key] = result;
    });
    return combinedResult;
  });
};
